import { useAtomValue } from 'jotai';

import { isGlobalAccount } from '../helpers/authorization';

import { cardState, currentAccountState, placesState } from '../store';

export default function useIsConfigured(): boolean {
  const currentAccount = useAtomValue(currentAccountState);
  const places = useAtomValue(placesState);
  const card = useAtomValue(cardState);

  if (isGlobalAccount(currentAccount)) {
    return true;
  }

  const hasPlace = Boolean(places.length);
  const hasCard = Boolean(card);

  return hasPlace && hasCard;
}
